import React from 'react'
import { CommonSvgContent } from "./CommonSvgContent"
import { ContentLanding } from "./ContentLanding"
import {Link} from 'react-router-dom';

export const Come = (props) => {

  const room = props.room;

  const stars = [];
  for (let i = 0; i < 60; i++) {
    // const posx = Math.floor(Math.random() * 100);
    // const posy = Math.floor(Math.random() * 100);
    // const w = Math.floor(Math.random() * 5) + 2;
    stars.push(<div className="star" key={i}  />);
  }

  return(
    <div className="pages" >
      {stars}

      <div className='logoMuseo'>
        <CommonSvgContent stringToRet="logoMuseo" />
      </div>

      <div className='collaborazione'>
        <p>In collaborazione con</p>
        <h3>INAF-Osservatorio<br />
        Astronomico<br />
        di Brera </h3>
      </div>

      <div className='logo'>
        <Link to="/"><ContentLanding stringToRet="logo" /></Link>
      </div>

      <div className="content">

        <h1>Come funziona</h1>
        <h2>COSA SERVE PER GIOCARE?</h2>
        <p>Basta avere un computer o un tablet con connessione a internet, senza nuove app da installare. Se vuoi giocare in gruppo, puoi scegliere tra due modalità: ritrovarti nello stesso luogo e usare lo stesso dispositivo oppure condividere il tuo schermo con gli altri partecipanti tramite una videochiamata. Potresti usare anche lo smartphone ma non è la modalità consigliata.</p>
        <h2>QUANTI GIOCATORI SONO AMMESSI?</h2>
        <p>Non esiste un limite al numero di partecipanti ma la fruizione ottimale dell’esperienza si ottiene con un gruppo massimo di 6 persone.</p>
        <h2>C’E’ UN’ETA’ MINIMA PER PARTECIPARE?</h2>
        <p>Questa escape room è consigliata a partecipanti dai 12 anni in su. È comunque possibile includere nel gruppo anche giocatori più giovani, ognuno può dare il suo contributo!</p>
        <h2>QUANTO DURA UNA PARTITA?</h2>
        <p>All’inizio del gioco scatta un timer di 90 minuti. Hai un’ora e mezza per venire a capo del mistero di Margherita Hacker risolvendo tutti gli enigmi e giungendo alla conclusione finale. Se non hai risolto il mistero entro 90 minuti, la partita si interrompe e vedrai il GAME OVER. È tutto nelle tue mani, potresti impiegare anche meno tempo per arrivare alla soluzione!</p>
        <h2>PERCHE’ AD INIZIO GIOCO MI VIENE CHIESTO DI INSERIRE UN NICKNAME?</h2>
        <p>Il nickname è un nome di fantasia (può essere anche il tuo nome) che sarà visualizzato pubblicamente unitamente al tempo di risoluzione dell’escape room nel caso entrassi in classifica tra i primi dieci.</p>
        <h2>PER RISOLVERE GLI ENIGMI POSSO CERCARE AIUTI SUL WEB?</h2>
        <p>Certo! Anzi, in alcuni casi sarà l’escape room stessa a mandarti su siti esterni per trovare indizi o la soluzione all’enigma. Non avere paura di fare ricerche online, spesso la soluzione si trova ad un clic da te!</p>
        <h2>POSSO INTERROMPERE LA PARTITA E RIPRENDERLA IN UN SECONDO MOMENTO?</h2>
        <p>Se chiudi il programma di navigazione o si interrompe la connessione internet prima che il tempo sia scaduto, hai la possibilità di riprendere la partita dal punto in cui eri rimasto, in qualsiasi momento reinserendo il codice di gioco.</p>
        <h2>UNA VOLTA ACQUISTATA L’ESPERIENZA, HO UN TEMPO LIMITE PER INIZIARE LA PARTITA?</h2>
        <p>No. Quando acquisti il biglietto digitale o una card fisica finché non inserisci il codice di gioco sul sito l’esperienza non ha scadenza.</p>

        <h2>HO INSERITO IL CODICE DI GIOCO SUL SITO ESCAPE E ATTIVATO IL GIOCO, POSSO PASSARE LO STESSO CODICE A UN MIO AMICO/A?</h2>
        <p>No. Una volta attivato il codice sul sito escapemarte.museoscienza.it non sarà più utilizzabile e cedibile.</p>
        <h2>HO ACQUISTATO UNA CARD CON UN CODICE DI GIOCO MA NON HO ANCORA ATTIVATO IL CODICE SUL SITO ESCAPEMARTE.MUSEOSCIENZA.IT, POSSO REGALARE LA CARD O PRESTARLA AD UN AMICO/A?</h2>
        <p>Certamente. Finché il codice di gioco presente sulla card non viene inserito sul sito e validato, il codice resta valido e non è legato all’acquirente della card.</p>
        <h2>SE NON RISOLVO IL GIOCO ENTRO I 90 MINUTI, POSSO RITENTARE?</h2>
        <p>Se il countdown presente all’interno del gioco giunge a zero, hai perso la partita e non è possibile giocare nuovamente.</p>
        <h2>SE TERMINO IL GIOCO ENTRO I 90’ POSSO FARE UN’ALTRA PARTITA?</h2>
        <p>No, una volta terminato il gioco il codice non è più valido ed è necessario acquistare un nuovo codice.</p>
        <h2>MENTRE GIOCAVO HO CHIUSO PER ERRORE IL PROGRAMMA DI NAVIGAZIONE. POSSO RIPRENDERE LA PARTITA DAL PUNTO IN CUI ERO ARRIVATO?</h2>
        <p>Sì. Torna sul sito escapemarte.museoscienza.it e reinserisci il tuo codice di gioco, la partita riprenderà dal punto in cui avevi interrotto.</p>
        <h2>MENTRE GIOCAVO, LA CONNESSIONE A INTERNET SI E’ INTERROTTA. POSSO RIPRENDERE A GIOCARE QUANDO TORNA LA CONNESSIONE?</h2>
        <p>Sì. Torna sul sito escapemarte.museoscienza.it e reinserisci il tuo codice di gioco, la partita riprenderà dal punto in cui avevi interrotto.</p>
        <h2>SE MI BLOCCO E NON RIESCO A PROCEDERE?</h2>
        <p>Ogni enigma ha 3 aiuti che puoi consultare. Puoi decidere in ogni momento se utilizzarli o meno. Gli aiuti sono contraddistinti da una numerazione da 1 a 3.
        Più cresce il numero più l’aiuto sarà preciso e ti indirizzerà verso la soluzione dell’enigma. In alcuni casi l’aiuto numero 3 potrebbe darti addirittura la soluzione all’enigma. Utilizza questi aiuti con attenzione per non rovinarti il divertimento. L’utilizzo degli aiuti non comporta una penalità di tempo ma a fine partita ti verrà evidenziato il numero di aiuti utilizzati. Nel caso entrassi in classifica, accanto al tuo nickname apparirà il numero eventuale di aiuti utilizzati.</p>
        <h2>DEVO AVERE CONOSCENZE DI ASTRONOMIA PER GIOCARE?</h2>
        <p>No, per giocare e risolvere gli enigmi non sono richieste competenze specifiche.</p>
        <Link className="btn btn-danger backTo" to="/">Torna</Link>

      </div>


    </div>
  )
}
